import React, { useContext } from 'react';
import useScreenSize from '../../../utils/useScreenSize';
import { ReaderContext } from '../../Reader/ReaderContext';
import { Box, SvgIcon } from '@mui/material';
import { Button } from '@mui/material';
import { spaces } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';
import { readerNavigationButtonStyle } from '../ReaderContent/ReaderContent';
import { useTranslation } from 'react-i18next';
import useRouter from '../../../utils/useRouter';
import { getReaderSiblingLink } from '../../../utils/pageSource';

const VideoReaderButtons = () => {
  const { router } = useRouter();
  const { isXsScreen } = useScreenSize();
  const { t } = useTranslation();
  const {
    previousSibling,
    nextSibling,
  } = useContext(ReaderContext);
    
  return (
    <Box 
      data-testid='video-reader-buttons'
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        gap: spaces.xs,
      }}>
      {
        previousSibling && (
          <Button 
            data-testid='video-reader-buttons-previous-button'
            sx={readerNavigationButtonStyle}
            onClick={() => router.push(getReaderSiblingLink(previousSibling.id))}
            type='button'
            aria-label={isXsScreen ? t('Reader.Previous') : t('Previous unit')}
            startIcon={
              <SvgIcon 
                component={getMuiIcon('readerBackButton')}
                sx={{ width: '25px', height: '24px' }}
                aria-hidden='true'
              />
            }>
            {`${isXsScreen ? t('Reader.Previous') : t('Previous unit')}`}
          </Button>
        )
      }
      {
        nextSibling && (
          <Button 
            data-testid='video-reader-buttons-next-button'
            sx={readerNavigationButtonStyle} 
            onClick={() => router.push(getReaderSiblingLink(nextSibling.id))}
            type='button'
            aria-label={isXsScreen ? t('Reader.Next') : t('Next unit')}
            endIcon={
              <SvgIcon 
                component={getMuiIcon('readerNextButton')}
                sx={{ width: '25px', height: '24px' }}
                aria-hidden='true'
              />
            }>
            {`${isXsScreen ? t('Reader.Next') : t('Next unit')}`}
          </Button>
        )
      }
    </Box>
  );
};

export default VideoReaderButtons;
